// extracted by mini-css-extract-plugin
module.exports = {"s1j91s21":"s1j91s21","s14qet46":"s14qet46","p7a6phg":"p7a6phg"};